import { render } from "./app-header-cart.vue?vue&type=template&id=64af5829&scoped=true&lang=true"
import script from "./app-header-cart.vue?vue&type=script&lang=js"
export * from "./app-header-cart.vue?vue&type=script&lang=js"

import "./app-header-cart.vue?vue&type=style&index=0&id=64af5829&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64af5829"]])

export default __exports__